import pdfMake from 'pdfmake/build/pdfmake'
import font from 'pdfmake/build/vfs_fonts'
import moment from 'moment';

import {
  invoiceInfo,
  lineItems,
  summary,
  styles,
} from './index';

import {
  header,
  line,
} from '../core';

const clientInfo = (client) => {
  const info = [];
  const city = client.city ? client.city : "";
  const province = client.province ? client.province : "";
  const country = client.country ? client.country : "";

  info.push({ text: "Billed To", style: "infoHeaderText" });
  info.push({ text: client.fullName ? client.fullName : "" });
  client.address && info.push({ text: client.address });
  client.city && info.push({ text: `${city} ${province} ${country}` });
  client.postalCode && info.push({ text: client.postalCode });

  return info;
};

export const generateInvoicePDF = (invoice, companyInfo, client) => {
  const dd = {
    content: [],
    styles: styles
  };

  dd.content.push(header("INVOICE", companyInfo));
  dd.content.push(invoiceInfo(invoice, client));
  dd.content.push(line());
  dd.content.push(lineItems(invoice));
  dd.content.push(line());
  dd.content.push(summary(invoice));

  pdfMake.vfs = font.pdfMake.vfs
  const pdf = pdfMake.createPdf(dd);

  return pdf;
}



// WEBPACK FOOTER //
// ./src/store/generators/PDF/invoice/generateInvoicePDF.js